import React from "react";
import { APIError } from "../utils/ErrorHandling";
import { ErrorDisplay } from "../utils/ErrorHandling";

export const useErrorHandler = (options?: {
  messageSource?: "default" | "api";
  renderText?: boolean;
}) => {
  const [error, setError] = React.useState<APIError | null>(null);

  const handleError = React.useCallback((err: APIError) => {
    setError(err);
  }, []);

  const clearError = React.useCallback(() => {
    setError(null);
  }, []);

  const ErrorComponent = React.useMemo(
    () => (
      <>
        {error && (
          <ErrorDisplay
            renderText={options?.renderText}
            error={error}
            messageSource={options?.messageSource}
            errorHandledCallback={clearError}
          />
        )}
      </>
    ),
    [error, options?.renderText, options?.messageSource, clearError],
  );

  return { handleError, clearError, ErrorComponent, error };
};
